import { render, staticRenderFns } from "./pcPage.vue?vue&type=template&id=7fbd2772&scoped=true&"
import script from "./pcPage.vue?vue&type=script&lang=js&"
export * from "./pcPage.vue?vue&type=script&lang=js&"
import style0 from "./pcPage.vue?vue&type=style&index=0&id=7fbd2772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbd2772",
  null
  
)

export default component.exports